<template>
    <div>
        <div class="col-12 mb-2">
            <label class="my-3">Selecione as categorias a serem exibidas neste card de loja :</label>
            <div class="list-categories py-2 d-flex align-items-center mb-4">
                <span
                    class="list-categories-item mr-3"
                    :class=" storeCategories.length === 0 ? 'item-active' : 'item--inactive' "
                    @click="clearCategory()"
                    >Todas</span
                >
                <span
                    class="list-categories-item mr-3"
                    :class="checkActiveCategory(item.idDepartamento)"
                    v-for="item in totalCategories"
                    :key="item.idDepartamento"
                    @click="handleCategory(item)"
                    >{{ item.Nome }}</span
                >
            </div>
            <span class='description'>
                Edite a quantidade de items e o layout na área de Design.
            </span>
        </div>
    </div>
</template>

<script>
import apiMixins from "@/mixins/apiMixins";

export default {
    name: "StoreCategories",
    data() {
        return {
            storeCategories:[],
            totalCategories:[]
        }
    },
    mixins: [apiMixins],
	props: {
        postOptions:{
            // type: Object,
            required: false,
        }
    },
    created(){
        console.log('storeCategories');
        if(this.postOptions && this.postOptions.store_categories){
            this.storeCategories = this.postOptions.store_categories
        }
        this.editStore()
    },
    methods:{
        //abre modal para editar store
        async editStore(){
            const url = `/site/${this.$session.get("siteId")}/store/categories`
            const getCategories = await this.requestApiData(url, 'get')
            if(getCategories.message.categories){
                this.mountArrayCategories(getCategories.message.categories)
            }
        },

        //Monta array com todas as categorias
        mountArrayCategories(array){
            array.forEach(element => {
                let subDepartamentos = element.subDepartamentos
                element.subDepartamentos = []
                this.totalCategories.push(element)
                this.mountArrayCategories(subDepartamentos)
            });
        },

        checkActiveCategory(id) {
            return this.storeCategories.some((c) => c.idDepartamento == id )
                ? "item-active"
                : "item--inactive";
        },

        handleCategory(item) {
            if (this.storeCategories.some((c) => c.idDepartamento == item.idDepartamento )
            ) {
                const category = this.storeCategories.findIndex(
                    (c) => c.idDepartamento == item.idDepartamento
                );
                this.storeCategories.splice(category, 1);
            } else {
                this.storeCategories.push(item);
            }
            this.$emit('options',this.storeCategories)
        },
        clearCategory(){
            this.storeCategories = []
            this.$emit('options',this.storeCategories)
        }
    }
}
</script>

<style scoped>
    .list-categories{
        flex-wrap: wrap;
    }
	.list-categories .list-categories-item {
		background-color: #f8f8f8;
		padding: 3px 15px;
		border-radius: 20px;
		color: #a9a9a9;
		border: 1px solid transparent;
		display: inline-block;
		cursor: pointer;
		margin-bottom: 8px;
	}
	.list-categories .list-categories-item.item-active {
		border: 1px solid var(--main-color);
		color: #000;
	}
    .description{
	text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #6e6e6e;
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
}
</style>


// WEBPACK FOOTER //
// src/components/blocks/StoreCategories.vue